/**
 * 嘉宾状态枚举
 *
 * 嘉宾状态流转：
 * PENDING_INVITE -> INVITED -> CONFIRMED -> CHECKED_IN -> LEFT
 *                                        -> LEFT (提前离开)
 */
export enum GuestStatus {
  /** 待邀约 - 嘉宾信息已录入但尚未发送邀约 */
  PENDING_INVITE = 'PENDING_INVITE',
  /** 已邀约 - 邀约已发送，等待嘉宾确认 */
  INVITED = 'INVITED',
  /** 已确认 - 嘉宾已确认参会 */
  CONFIRMED = 'CONFIRMED',
  /** 已签到 - 嘉宾已现场签到 */
  CHECKED_IN = 'CHECKED_IN',
  /** 已离开 - 嘉宾已离会 */
  LEFT = 'LEFT',
}

/** 所有状态值的数组 */
export const GuestStatusValues: string[] = Object.values(GuestStatus);

/** 状态中文标签映射 */
export const GuestStatusLabels: Record<GuestStatus, string> = {
  [GuestStatus.PENDING_INVITE]: '待邀约',
  [GuestStatus.INVITED]: '已邀约',
  [GuestStatus.CONFIRMED]: '已确认',
  [GuestStatus.CHECKED_IN]: '已签到',
  [GuestStatus.LEFT]: '已离开',
};

/** 合法的状态流转映射 */
export const GuestStatusTransitions: Record<GuestStatus, GuestStatus[]> = {
  [GuestStatus.PENDING_INVITE]: [GuestStatus.INVITED],
  [GuestStatus.INVITED]: [GuestStatus.CONFIRMED, GuestStatus.LEFT],
  [GuestStatus.CONFIRMED]: [GuestStatus.CHECKED_IN, GuestStatus.LEFT],
  [GuestStatus.CHECKED_IN]: [GuestStatus.LEFT],
  [GuestStatus.LEFT]: [],
};
